module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-customer-hours"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Svendenes tid hos kunderne\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.series,
      "type": "line"
    }
  }) : _c('box-loading', {
    attrs: {
      "height": "400"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f18f122"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/components/compareCustomerHours.vue
// module id = 880
// module chunks = 0